/**
 * A stored subject address as one line: street, city, province, postal code, country — the order
 * of the server's `identity_declarations::fields::format_address`. A Vietnamese address of the
 * place list is stored with `city` = the ward and `province` = the province
 * (`identity_subjects::model::Address::vn`), so it reads ward before province. Every screen that
 * shows a stored address writes it with this function (tests/address-line.test.mjs).
 */
export interface StoredAddress {
  street: readonly string[];
  city: string;
  province: string | null;
  postal_code: string | null;
  country_code: string;
}

export function addressLine(a: StoredAddress): string {
  const parts: string[] = [];
  for (const p of [...a.street, a.city, a.province, a.postal_code, a.country_code]) {
    const v = (p ?? '').trim();
    if (v && !parts.includes(v)) parts.push(v);
  }
  return parts.join(', ');
}
